import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { GET_CHAT_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const KycPopup = (props) => {
    const { kycModalText, kycModalSubmit, kycModalCancel } = usePageMessages();
    return (
        <SimplePopup popupRef={props.popupRef} text={<DangerouslyHtml dangerouslyHtml={kycModalText} />}>
            <PopupButton
                iconName="lifebuoy"
                text={kycModalSubmit}
                onClick={(e) => {
                    e.preventDefault();
                    amplitude.getInstance().logEvent(GET_CHAT_CLICKED);
                    props.toggleChat(true);
                    props.popupRef.current?.close();
                }}
            />
            <PopupButton
                iconName="cross"
                text={kycModalCancel}
                onClick={(e) => {
                    e.preventDefault();
                    props.popupRef.current?.close();
                }}
            />
        </SimplePopup>
    );
};

export default connect(null, { toggleChat })(KycPopup);
